import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import withOptions from 'utils/functions/withOptions.util';
import actionType from 'utils/mw/actionType.util';

const ATAG = 'beUpgradePlan';
const AT = actionType(ATAG);

const beUpgradePlan = withOptions(({ salonId, planId }) =>
  endpoint(H.post, `billing/:salonId/plan/upgrade/`, {
    AT,
    name: ATAG,
    ATAG,
    params: { salonId, newId: planId },
    data: { pricing_plan_id: planId },
  }),
);

beUpgradePlan.AT = AT;
beUpgradePlan.ATAG = ATAG;

// noinspection JSUnusedGlobalSymbols
export default beUpgradePlan;
